import { render } from "./FaireTestQCMPage.vue?vue&type=template&id=15f280de&ts=true"
import script from "./FaireTestQCMPage.vue?vue&type=script&lang=ts"
export * from "./FaireTestQCMPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__